import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

// Pagination simple côté client : « ‹ 1/8 › » + compteur.
export const SimplePager = ({ page, total, perPage, onChange, testid }) => {
  const pages = Math.max(1, Math.ceil(total / perPage));
  if (pages <= 1) return null;
  const from = page * perPage + 1;
  const to = Math.min(total, (page + 1) * perPage);
  return (
    <div className="flex items-center justify-between gap-2 px-3 py-2 border-t text-xs text-slate-500"
         data-testid={testid}>
      <span>{from}–{to} sur {total}</span>
      <div className="flex items-center gap-1">
        <Button size="sm" variant="ghost" className="h-7 w-7 p-0" disabled={page === 0}
                onClick={() => onChange(page - 1)} data-testid={`${testid}-prev`}>
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="font-mono" data-testid={`${testid}-label`}>{page + 1}/{pages}</span>
        <Button size="sm" variant="ghost" className="h-7 w-7 p-0" disabled={page >= pages - 1}
                onClick={() => onChange(page + 1)} data-testid={`${testid}-next`}>
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
